export default __webpack_public_path__ + "static/media/kh.e4137a50.png";